import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import Logo from "./Logo";

const AdminShell = ({ children, title, testId }) => {
  const nav = useNavigate();
  const logout = () => {
    localStorage.removeItem("spinlab_token");
    localStorage.removeItem("spinlab_user");
    nav("/admin");
  };

  return (
    <div data-testid={testId} className="min-h-screen bg-black text-gray-200">
      <header className="border-b border-gray-900 px-6 md:px-10 py-6 flex items-center justify-between sticky top-0 bg-black/95 backdrop-blur-xl z-40">
        <Link to="/" className="flex items-center" aria-label="Public site">
          <Logo size="sm" testId="admin-shell-logo" />
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          <NavLink
            to="/admin/leads"
            data-testid="admin-nav-leads"
            className={({ isActive }) =>
              `text-[11px] font-display font-light uppercase tracking-[0.25em] ${
                isActive ? "text-white" : "text-gray-500 hover:text-white"
              }`
            }
          >
            Leads
          </NavLink>
        </nav>
        <button
          data-testid="admin-logout-btn"
          onClick={logout}
          className="inline-flex items-center gap-2 px-4 py-2 border border-gray-800 text-[10px] font-display font-light uppercase tracking-[0.3em] text-gray-300 hover:border-gray-400 hover:text-white transition-all"
        >
          <LogOut strokeWidth={1} size={14} />
          Logout
        </button>
      </header>
      <div className="px-6 md:px-10 py-10">
        {title && (
          <h1 className="font-display font-extralight uppercase tracking-[0.25em] text-white text-2xl md:text-3xl mb-10">
            {title}
          </h1>
        )}
        {children}
      </div>
    </div>
  );
};

export default AdminShell;
